// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.banner-var {
  --header-height: 390px;
}

.banner {
  width: auto;
  max-width: 1400px;
  height: var(--header-height);
  background-size: auto var(--header-height);
  background-position: center;
  background-repeat: no-repeat;
  margin: 0 auto 1.5rem auto;
  position: relative;
}

.banner-body {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: auto;
  width: 90%;
  height: 100%;
  align-items: center;
}

.banner-title {
  line-height: 1;
  width: 600px;
  padding-top: 0;
}

.banner-image {
  padding: 0;
  margin: auto;
  width: 100%;
  height: 100%;
  object-fit: scale-down;
  max-height: 160px;
  border-radius: 5px;
}

.image-column {
  grid-column: max-content;
}

.title-column {
  text-align: center;
  grid-column: max-content;
}

  .title-column.dark {
    background-color: black;
    opacity: 0.7;
    padding: 15px;
    color: white;
  }

@media (min-width: 992px) {
  .image-column {
    grid-column: span 1;
  }

  .title-column {
    text-align: left;
    grid-column: span 2;
  }
}

@media (min-width: 992px) {
  .banner-image {
    max-height: 200px;
  }
}

@media (max-width: 992px) {
  .banner-body {
    width: 100%;
    flex-direction: column;
    justify-content: space-evenly;
  }

    .banner-body > * {
      width: 100%;
    }

  .title-column > * {
    width: 100%;
  }
}

.card__link {
  text-decoration: none;
  color: black;
}

:host ::ng-deep {
   .p-carousel-container {
      display: inline;
      flex-direction: row;
   }
  
  .p-carousel .p-carousel-prev,
  .p-carousel .p-carousel-next {
    display: none;
  }
  
  .p-carousel .p-carousel-indicators .p-carousel-indicator {
    margin-right: 0.5rem;
    margin-bottom: 0.5rem;
  }
  
  .p-carousel .p-carousel-indicators .p-carousel-indicator button {
    background-color: #e9ecef;
    width: 1rem;
    height: 0.5rem;
    transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
    border-radius: 0;
  }
  
  .p-carousel .p-carousel-indicators .p-carousel-indicator button:hover {
    background-color: #dee2e6;
  }
  
  .p-carousel .p-carousel-indicators .p-carousel-indicator.p-highlight button {
    background-color: #b3d4fc;
    color: #495057;
  }

  .hide-paginator .p-carousel-indicators {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/uilib/carousel/carousel.component.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,4BAA4B;EAC5B,0CAA0C;EAC1C,2BAA2B;EAC3B,4BAA4B;EAC5B,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;EAEE;IACE,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,YAAY;EACd;;AAEF;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,WAAW;IACX,sBAAsB;IACtB,6BAA6B;EAC/B;;IAEE;MACE,WAAW;IACb;;EAEF;IACE,WAAW;EACb;AACF;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;GACG;MACG,eAAe;MACf,mBAAmB;GACtB;;EAED;;IAEE,aAAa;EACf;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,cAAc;IACd,8DAA8D;IAC9D,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".banner-var {\r\n  --header-height: 390px;\r\n}\r\n\r\n.banner {\r\n  width: auto;\r\n  max-width: 1400px;\r\n  height: var(--header-height);\r\n  background-size: auto var(--header-height);\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n  margin: 0 auto 1.5rem auto;\r\n  position: relative;\r\n}\r\n\r\n.banner-body {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  margin: auto;\r\n  width: 90%;\r\n  height: 100%;\r\n  align-items: center;\r\n}\r\n\r\n.banner-title {\r\n  line-height: 1;\r\n  width: 600px;\r\n  padding-top: 0;\r\n}\r\n\r\n.banner-image {\r\n  padding: 0;\r\n  margin: auto;\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: scale-down;\r\n  max-height: 160px;\r\n  border-radius: 5px;\r\n}\r\n\r\n.image-column {\r\n  grid-column: max-content;\r\n}\r\n\r\n.title-column {\r\n  text-align: center;\r\n  grid-column: max-content;\r\n}\r\n\r\n  .title-column.dark {\r\n    background-color: black;\r\n    opacity: 0.7;\r\n    padding: 15px;\r\n    color: white;\r\n  }\r\n\r\n@media (min-width: 992px) {\r\n  .image-column {\r\n    grid-column: span 1;\r\n  }\r\n\r\n  .title-column {\r\n    text-align: left;\r\n    grid-column: span 2;\r\n  }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n  .banner-image {\r\n    max-height: 200px;\r\n  }\r\n}\r\n\r\n@media (max-width: 992px) {\r\n  .banner-body {\r\n    width: 100%;\r\n    flex-direction: column;\r\n    justify-content: space-evenly;\r\n  }\r\n\r\n    .banner-body > * {\r\n      width: 100%;\r\n    }\r\n\r\n  .title-column > * {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.card__link {\r\n  text-decoration: none;\r\n  color: black;\r\n}\r\n\r\n:host ::ng-deep {\r\n   .p-carousel-container {\r\n      display: inline;\r\n      flex-direction: row;\r\n   }\r\n  \r\n  .p-carousel .p-carousel-prev,\r\n  .p-carousel .p-carousel-next {\r\n    display: none;\r\n  }\r\n  \r\n  .p-carousel .p-carousel-indicators .p-carousel-indicator {\r\n    margin-right: 0.5rem;\r\n    margin-bottom: 0.5rem;\r\n  }\r\n  \r\n  .p-carousel .p-carousel-indicators .p-carousel-indicator button {\r\n    background-color: #e9ecef;\r\n    width: 1rem;\r\n    height: 0.5rem;\r\n    transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;\r\n    border-radius: 0;\r\n  }\r\n  \r\n  .p-carousel .p-carousel-indicators .p-carousel-indicator button:hover {\r\n    background-color: #dee2e6;\r\n  }\r\n  \r\n  .p-carousel .p-carousel-indicators .p-carousel-indicator.p-highlight button {\r\n    background-color: #b3d4fc;\r\n    color: #495057;\r\n  }\r\n\r\n  .hide-paginator .p-carousel-indicators {\r\n    display: none;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
